/**
 * Calcula si un punto está dentro de alguna zona de envío y devuelve el precio asociado.
 * Misma lógica que GoogleMapSelector (polígonos + geometry.poly.containsLocation).
 *
 * @param {Array} zonasApi Respuesta de api/zonas/:code (cada ítem: Precio, ListaCoordenada[])
 * @param {number} lat
 * @param {number} lng
 * @param {object} googleMaps window.google tras cargar el SDK
 * @returns {{ precio: number|null, enZona: boolean }}
 */
export function precioEnvioPorCoordenadas (zonasApi, lat, lng, googleMaps) {
  if (!zonasApi || !Array.isArray(zonasApi) || lat == null || lng == null) {
    return { precio: null, enZona: false }
  }
  const latN = Number(lat)
  const lngN = Number(lng)
  if (Number.isNaN(latN) || Number.isNaN(lngN)) {
    return { precio: null, enZona: false }
  }
  if (!googleMaps || !googleMaps.maps || !googleMaps.maps.geometry || !googleMaps.maps.geometry.poly) {
    return { precio: null, enZona: false }
  }

  const { Polygon } = googleMaps.maps
  const point = new googleMaps.maps.LatLng(latN, lngN)

  for (let i = 0; i < zonasApi.length; i++) {
    const z = zonasApi[i]
    const lista = z.ListaCoordenada || z.Lista || []
    if (!lista.length) continue
    const paths = lista.map((l) => ({
      lat: parseFloat(l.Latitud),
      lng: parseFloat(l.Longitud)
    })).filter((p) => !Number.isNaN(p.lat) && !Number.isNaN(p.lng))
    if (paths.length < 3) continue

    const poligono = new Polygon({
      paths,
      strokeColor: z.Color || '#000000',
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: z.Color || '#000000',
      fillOpacity: 0.35
    })

    if (googleMaps.maps.geometry.poly.containsLocation(point, poligono)) {
      // Misma idea que GoogleMapSelector: el punto en zona basta. Si Precio no parsea, 0
      // (o costo fijo de tienda) evita tratar "en zona" como "fuera de entrega" en el checkout.
      const precio = parseInt(z.Precio, 10)
      return { precio: Number.isNaN(precio) ? 0 : precio, enZona: true }
    }
  }

  return { precio: null, enZona: false }
}
